/** A thumbs reaction, shared by every explicit-feedback surface (nuggets, chat turns, ...). */
export type Reaction = "UP" | "DOWN";

/** The requesting user's own feedback on some subject. `reaction` is null when they have none. */
export type FeedbackState = {
  reaction: Reaction | null;
  comment: string | null;
};

export function isReaction(value: unknown): value is Reaction {
  return value === "UP" || value === "DOWN";
}

/** What clicking `clicked` does to `current`, mirroring the backend's rules exactly.
 *
 * Used only to paint the thumb before the response lands; the server's answer always
 * overwrites it on `fulfilled`, so any drift here is transient and self-correcting.
 * Re-clicking the active reaction clears it — unless a comment is attached, since deleting
 * the row would take the user's text with it. */
export function nextFeedbackAfterReactionClick(
  current: FeedbackState | null | undefined,
  clicked: Reaction,
): FeedbackState {
  const hasComment = Boolean(current?.comment?.trim());
  if (current?.reaction === clicked && !hasComment) {
    return { reaction: null, comment: null };
  }
  return { reaction: clicked, comment: current?.comment ?? null };
}
